import React from "react";
import "./InvestingFoundation.css";
import image1 from "./feature_1--desktop--new.png";
import image2 from "./feature_2--desktop.png";
import image3 from "./feature_3--desktop.png";
const InvestingFoundation = () => {
  return (
    <>
      <main className="investing-foundation-area">
        <div id="features" data-id="features">
          <section
            className="svelte-rl42o9"
            style={{ backgroundColor: "#161a25", overflow: "hidden" }}
          >
            <div className="layout svelte-iq32t8">
              <div className="text-content svelte-pqe62f">
                <h2 className="svelte-qgcp45" style={{ color: "#fff" }}>
                  Build your investing foundation
                </h2>
                <h3
                  className="svelte-lox3er"
                  style={{
                    color: "#aeb2be",
                    margin: "15px auto 40px",
                    maxWidth: "770px",
                  }}
                >
                  We all have to start somewhere. Let us help you enhance your
                  trading knowledge throughout your trading journey. With our
                  video tutorials section, you'll be ready to start in no time.
                </h3>
              </div>
              <div className="features-slider-wrap svelte-pqe62f" dir="ltr">
                <div
                  className="features_slider siema svelte-aqinqg"
                  data-id="slider_features"
                  dir="ltr"
                >
                  <div
                    className="slide-wrap svelte-1oz8v1z"
                    lang="en"
                    style={{ transition: "0.5s", opacity: "1" }}
                  >
                    <div className="slide svelte-1oz8v1z">
                      <div className="caption svelte-1oz8v1z">
                        Use smart Newsfeed to make informed decisions
                      </div>
                      <picture className="svelte-1oz8v1z">
                        <img
                          alt="Use smart Newsfeed to make informed decisions"
                          src={image1}
                          className="svelte-1oz8v1z"
                        />
                      </picture>
                    </div>
                  </div>
                  <div
                    className="slide-wrap svelte-1oz8v1z"
                    lang="en"
                    style={{ transition: "0.5s", opacity: "1" }}
                  >
                    <div className="slide svelte-1oz8v1z">
                      <div className="caption svelte-1oz8v1z">
                        Invest wisely with a variety of indicators
                      </div>
                      <picture className="svelte-1oz8v1z">
                        <img
                          alt="Invest wisely with a variety of indicators"
                          src={image2}
                          className="svelte-1oz8v1z"
                        />
                      </picture>
                    </div>
                  </div>
                  <div
                    className="slide-wrap svelte-1oz8v1z"
                    lang="en"
                    style={{ transition: "0.5s", opacity: "1" }}
                  >
                    <div className="slide svelte-1oz8v1z">
                      <div className="caption svelte-1oz8v1z">
                        Harness the power of a supportive community
                      </div>
                      <picture className="svelte-1oz8v1z">
                        <img
                          alt="Harness the power of a supportive community"
                          src={image3}
                          className="svelte-1oz8v1z"
                        />
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default InvestingFoundation;
